import signinOrganizationTemplateUrl from './signinorganization.tpl.html';

export default {
    templateUrl: signinOrganizationTemplateUrl,
    controller: [
        'SUBDOMAIN_ROOT',
        '$scope',
        '$window',
        'ssoRedirect',
        function (SUBDOMAIN_ROOT, $scope, $window, ssoRedirect) {
            $scope.SUBDOMAIN_ROOT = SUBDOMAIN_ROOT;

            $scope.state = '';
            $scope.domain = '';

            $scope.submit = function () {
                $scope.state = 'loading';
                let url = ssoRedirect.getAndClear() || '';
                // Redirect to '/home' when the cookie - SF_SSO_REDIRECT
                // is set to redirect to a different org id i.e. /home/:orgId
                const urlParams = url.split('/');
                if (urlParams.length === 3 && urlParams[1] === 'home') {
                    url = '/home';
                }

                const domain = ($scope.domain || '').trim().toLowerCase();
                if (!/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(domain)) {
                    $scope.state = 'error';
                    return;
                }
                const orgUrl = 'https://' + domain + '.' + SUBDOMAIN_ROOT;
                fetch(orgUrl + '/healthz', { method: 'GET', mode: 'no-cors' })
                    .then(() => {
                        $window.location.href = orgUrl + '/#' + url;
                    })
                    .catch(() => {
                        $scope.state = 'error';
                        $scope.$apply();
                    });
            };
        },
    ],
};
